export const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: value % 1 === 0 ? 0 : 2,
    }).format(value);
};

export const parseInvestment = (currentInvestment: string | number): number => {
    if (typeof currentInvestment === "string" && currentInvestment.includes("$") && currentInvestment.includes("M")) {
        return parseFloat(currentInvestment.slice(1, -1));
    } else if (typeof currentInvestment === "number") {
        return currentInvestment / 1e6;
    } else if (typeof currentInvestment === "string" && currentInvestment !== "") {
        return parseInt(currentInvestment) / 1e6;
    }
    else {
        return 0;
    }
};